import { render, staticRenderFns } from "./CompanyModalForm.vue?vue&type=template&id=4bd16f4f"
import script from "./CompanyModalForm.vue?vue&type=script&lang=js"
export * from "./CompanyModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports